import { useCallback } from 'react'
import { useWeb3React } from '@web3-react/core'
import { ConnectorNames, connectorLocalStorageKey } from 'vvs-uikit'
import { connectorsByName } from 'utils/web3React'
import useToast from 'hooks/useToast'
import { profileClear } from 'state/profile'
import { useAppDispatch } from 'state'
import { useTranslation } from 'contexts/Localization'
import { useConnectionError } from 'state/user/hooks'
import { getActivateErrorHandler } from 'utils/wallet'

const useAuth = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { activate, deactivate } = useWeb3React()
  const { toastError } = useToast()
  const [connectionError, setConnectionError] = useConnectionError()

  const login = useCallback(
    (connectorID: ConnectorNames) => {
      setConnectionError(null)
      const connector = connectorsByName[connectorID]
      if (typeof connector === 'string') {
        window.open(connector, '_blank', 'noopener,noreferrer')
      } else if (connector) {
        let walletName: string = connectorID
        // XXX: DeFiWallet append that to user-agent
        if (window.navigator.userAgent.includes('Crypto.com DeFiWallet')) {
          walletName = `${ConnectorNames.CDCDefiWallet} App`
        } else if (window.navigator.userAgent.includes('Desktop Wallet')) {
          walletName = `${ConnectorNames.CDCDefiWallet} Desktop`
        }
        window.gtag('event', 'wallet', {
          hitType: 'event',
          eventCategory: 'Wallet',
          eventAction: 'connect',
          eventLabel: walletName,
          userAgent: window.navigator.userAgent,
        })
        window.analytics.track('Connect Wallet', {
          category: 'wallet',
          action: 'connect',
          name: walletName,
          userAgent: window.navigator.userAgent,
        })
        const errorHandler = getActivateErrorHandler(connectorID, t, toastError, setConnectionError)
        activate(connector, errorHandler)
      } else {
        toastError(t('Unable to find connector'), t('The connector config is wrong'))
      }
    },
    [activate, setConnectionError, toastError, t],
  )

  const logout = useCallback(() => {
    dispatch(profileClear())
    deactivate()
    // This localStorage key is set by @web3-react/walletconnect-connector
    if (window.localStorage.getItem('walletconnect')) {
      connectorsByName.walletconnect.close()
      connectorsByName.walletconnect.walletConnectProvider = null
    }
    window.localStorage.removeItem(connectorLocalStorageKey)
  }, [deactivate, dispatch])

  return { login, logout }
}

export default useAuth
